import { memo } from 'react';
import { getQuoteProperty } from 'quotes-ui-lib/utils/quote';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Button } from 'foundations-components/transitional/components/Button';
import { isTrue } from 'quotes-ui-lib/utils/isTrue';
import { getIsArchived, getIsPublished } from 'quotes-ui-lib/utils/status';
import { jsx as _jsx } from "react/jsx-runtime";
const MarkSignedButton = ({
  quote,
  onClick
}) => {
  let disabledTooltipTitle = null;
  if (!isTrue(getQuoteProperty(quote, 'hs_show_signature_box'))) {
    disabledTooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.markSigned.notEligible"
    });
  } else if (isTrue(getQuoteProperty(quote, 'hs_manually_signed'))) {
    disabledTooltipTitle = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "quotesUiLib.quoteActions.markSigned.alreadyMarked"
    });
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabledTooltipTitle,
    disabled: !disabledTooltipTitle,
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "mark-signed-btn",
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: onClick,
      disabled: !!disabledTooltipTitle,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "quotesUiLib.quoteActions.markSigned.buttonText"
      })
    }, "mark-signed-button")
  });
};
export default /*#__PURE__*/memo(MarkSignedButton);
export const showMarkSignedButton = (quote, canCurrentUserEditQuote) => {
  return getIsPublished(quote) && !getIsArchived(quote) && canCurrentUserEditQuote;
};